import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_55_0 = () => {
  return (
    <div>
      <PageTitle title='3.55.0' />

      <ParaTitle paraTitle='PDF Format Updates & Bug Fixes' />
      <Paragraph paragraph='2026-09-30' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Investigate saving grievances to a different database
          <p>
            Evaluate the feasibility of storing selected events/grievances in a separate database.
          </p>
        </li>
        <li>
          Add PSWP to PDF Report
          <p>
            Add the Patient Safety Work Product (PSWP) designation to PDF reports.
          </p>
        </li>
        <li>
          Notify Managers When Suspicious Activity is Detected
          <p>
            Implement notifications to alert managers when suspicious user activity is detected, such as:
            <p>- Multiple failed login attempts</p>
            <p>- Login attempts from expired accounts</p>
            <p>- Multiple password reset requests</p>
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>
          Regular database maintenance
          <p>
            Remove unused tables and database users from the RCHI database to improve security and maintain a clean database environment.
          </p>
        </li>

        <li>
          Update Overview Report Formatting
          <p>
            Update the overview report’s header, fonts, footer, and layout to ensure consistent formatting across all reports.
          </p>
        </li>
        <li>
          Change the wording for Overview Reports
          <p>
            Update the labels in Reports – Overall – Overview (All Facilities) as follows:
            <p>PIF (Patient Information Form) → PATIENT COUNT</p>
            <p>HERF (Health Event Reporting Form / Event Report) → EVENT COUNT</p>
          </p>
        </li>
        <li>
          Update 404 Error Page
          <p>
          Remove the PPR link from the 404 error page to eliminate unnecessary links that are no longer needed.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
        Remove Print Functionality from Tables
          <p>
        Remove the print button from all tables at the widget level. The export functionality is sufficient for users to retrieve table data, and removing the print option will reduce the effort required to maintain table styling.
          </p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Home', link: '/' },
          next: { name: 'Updates: 3.54.0', link: '/updates/3.54.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_55_0;